import { RulesLayer } from "./RulesLayer";
import { LevelCompletedContainer } from "./LevelCompletedLayer";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import { HUD } from "./HUD";
import { GUI } from "./GUI";
import { BoardManager } from "./BoardManager";
import { PauseLayer } from "./PauseLayer";
import { BoardContainer } from "./BoardContainer";
import { GameVars } from "../../GameVars";
import { Background } from "../../Background";

export class BoardScene extends Phaser.Scene {

    public static currentInstance: BoardScene;

    private gui: GUI;
    private hud: HUD;
    private pauseLayer: PauseLayer;
    private boardContainer: BoardContainer;
    
    constructor() {

        super("BoardScene");
        
        BoardScene.currentInstance = this;
    }

    public create(): void {

        GameManager.setCurrentScene(this);

        BoardManager.init();

        const tmpBackground = this.add.graphics();
        tmpBackground.fillStyle(0xffffff);
        tmpBackground.fillRect(0, 0, GameConstants.GAME_WIDTH, GameConstants.GAME_HEIGHT);

        let background = new Background(this);
        this.add.existing(background);

        this.boardContainer = new BoardContainer(this);
        this.add.existing(this.boardContainer);

        this.hud = new HUD(this);
        this.add.existing(this.hud);

        this.gui = new GUI(this);
        this.add.existing(this.gui);

        if (GameVars.difficulty === GameConstants.DIFFICULTY_EASY && GameVars.currentLevel === 1) {
            this.hud.y = -100;
            this.gui.y = -100;
            this.showRulesLayer();
        }

        this.cameras.main.fadeIn(300, 255, 255, 255);
    }

    public showRulesLayer(): void {

        this.hud.hide();
        this.gui.hide();

        let rules = new RulesLayer(this);
        this.add.existing(rules);

        this.boardContainer.visible = false;
    }

    public onRulesRemoved(): void {

        this.hud.show();
        this.gui.show();

        this.boardContainer.visible = true;

        GameVars.paused = false;
    }

    public showPauseLayer(): void {

        this.hud.hide();
        this.gui.hide();

        this.boardContainer.visible = false;
        
        this.pauseLayer = new PauseLayer(this);
        this.add.existing(this.pauseLayer);
    }

    public hidePauseLayer(): void {

        this.hud.show();
        this.gui.show();

        this.boardContainer.visible = true;
    }

    public onLevelCompleted(): void {

        this.hud.hide();
        this.gui.hide();

        this.tweens.add({
            targets: this.boardContainer,
            alpha: 0,
            ease: Phaser.Math.Easing.Linear.Linear,
            duration: 250,
            delay: 250
        });

        let levelCompletedContainer = new LevelCompletedContainer(this);
        this.add.existing(levelCompletedContainer);
    }
}
